import React, { useState } from 'react';
import Button from 'components/Buttons/Button';
import InputTextArea from 'components/Inputs/inputTextArea';
import useDialog from 'components/Dialog/useDialog';
import OutputErrors from 'components/Inputs/outputErrors';
import { Breadcrumb } from 'xland-ui';
import { ROUTE_PATH } from 'routes';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { sendSupportMessage } from './modules/actions';

function Help() {
  const literals = useSelector(state => state.i18n.literals.help);
  const [helpInfo, setHelpInfo] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const { dialog } = useDialog();
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(ROUTE_PATH.PREHOME);
    }
  };

  const submitHelp = async () => {
    if (!helpInfo.trim()) {
      return;
    }

    try {
      setLoading(true);
      await sendSupportMessage(helpInfo);
      setHelpInfo('');
      await dialog({
        type: 'success',
        title: literals.sent,
      });
      goBack();
    } catch (error) {
      setErrors(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb routes={[{ name: literals.home, path: ROUTE_PATH.BASEROUTE }, { name: literals.help }]} />
      <div className='help-wrapper'>
        <InputTextArea
          preText={literals.form}
          onChange={setHelpInfo}
          value={helpInfo}
          errors={errors?.message}
          minHeight={150}
          placeholder={literals.helpPlaceholder}
        />
      </div>
      <OutputErrors errors={errors} />
      <div className='buttons'>
        <Button
          text={literals.submit}
          onClick={submitHelp}
          loading={loading}
          disabled={!helpInfo.trim() || loading}
        />
        <Button text={literals.cancel} color='outline-danger' onClick={goBack} disabled={loading} />
      </div>
    </>
  );
}

export default Help;
